<template>
    <div class="pcontent-model"> 
        <div  class="about">
            <slot></slot> <!-- 默认插槽，用于放置主要内容 -->
        </div>
    </div>
</template>

<script>
</script>
 
<style lang="scss" scoped>

@media screen and (max-width: 480px)  {
    .pcontent-model{
        width: 94% !important; 
        div{
            
            padding-left: 6px !important;
            padding-right: 6px !important; 
        }
    } 
}
.pcontent-model{  
    position: relative;
    padding-top: 15px;
    box-sizing: border-box;
    width: 60%; 
    margin: auto;
    div{
        position: relative;
        z-index: 99; 
        padding-left: 35px;
        padding-right: 35px; 
        text-align: left;
    }

}

</style>